import LoadingSpinner from '#atoms/LoadingSpinner';
import { produce } from 'immer';
import styled from 'styled-components';
import { match } from 'ts-pattern';
import { FileInfo } from './useFileUpload';

interface FileInfoListProps {
  fileInfoList: FileInfo[];
  setFileInfoList: React.Dispatch<React.SetStateAction<FileInfo[]>>;
  onDeleteFileComplete: (id: string, type: 'videos' | 'images') => void;
  setDetailFileInfo: React.Dispatch<
    React.SetStateAction<{
      url: string;
      isVideo: boolean;
    }>
  >;
  setIsDetailModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
export const FileInfoList = ({
  fileInfoList,
  setFileInfoList,
  onDeleteFileComplete,
  setDetailFileInfo,
  setIsDetailModalOpen
}: FileInfoListProps) => {
  // 선택한 파일 제거
  // aws에서 사용하지 않는 파일들을 주기적으로 삭제함
  // 직접 aws에 업로드된 파일을 삭제할 필요 없음
  const onRemove = async (id: string, type: 'videos' | 'images') => {
    setFileInfoList(
      produce(draft => draft.filter(fileInfo => fileInfo.id !== id))
    );

    onDeleteFileComplete(id, type);
  };

  return (
    <>
      {fileInfoList.map((fileInfo, index) => {
        const url = URL.createObjectURL(fileInfo.file);
        const isVideo = fileInfo.file.type.includes('video');

        const onClick = () => {
          setDetailFileInfo({
            url,
            // extractThumnail,
            isVideo
          });

          setIsDetailModalOpen(true);
        };

        return (
          <div className="relative" key={index} onClick={onClick}>
            <div
              key={index}
              className="w-120 h-120 rounded-lg overflow-hidden border-1 border-solid border-[#373245]"
            >
              {match(fileInfo.status)
                .with('loading', () => <LoadingSpinner py={50} />)
                .with('error', () => (
                  <div className="flex w-full h-full justify-center items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-alert-triangle"
                    >
                      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"></path>
                      <line x1="12" y1="9" x2="12" y2="13"></line>
                      <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    </svg>
                  </div>
                ))
                .otherwise(() =>
                  match(isVideo)
                    .with(true, () => (
                      <video
                        playsInline={true}
                        preload="metadata"
                        controls
                        className="w-full h-full object-contain"
                      >
                        <source src={url} type="video/mp4" />
                      </video>
                    ))
                    .with(false, () => (
                      <img
                        className="w-full h-full object-contain"
                        src={url}
                        alt="업로드한 이미지"
                      />
                    ))
                    .exhaustive()
                )}
            </div>
            {fileInfo.status !== 'loading' && (
              <StyledXButtonContainer
                onClick={e => {
                  e.stopPropagation();
                  URL.revokeObjectURL(url);
                  onRemove(
                    fileInfo.id,
                    fileInfo.file.type.includes('video') ? 'videos' : 'images'
                  );
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M13.1202 4.46004L11.7002 3.04004L8.1602 6.59004L4.6202 3.04004L3.2002 4.46004L6.7502 8.00004L3.2002 11.54L4.6202 12.96L8.1602 9.41004L11.7002 12.96L13.1202 11.54L9.5702 8.00004L13.1202 4.46004Z"
                    fill="#D7D3DE"
                  />
                </svg>
              </StyledXButtonContainer>
            )}
          </div>
        );
      })}
    </>
  );
};

const StyledXButtonContainer = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  display: inline-flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 50%;
  background: var(--bg-400, #413d50);

  /* button drop S */
  box-shadow: 0px 0px 10px 0px rgba(34, 34, 34, 0.25);
`;
